import { Container } from "@mui/material";
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
import useLocales from "src/hooks/useLocales";
import useTabs from "src/hooks/useTabs";

import AnalyticsPanel from "../Overview/AnalyticsPanel";
import ServiceTab from "../Transactions/ServiceTab";
import CreateUrlTab from "./CreateUrlTab";

// ----------------------------------------------------------------------

export const AppPositions = () => {
	const { currentTab, onChangeTab } = useTabs("analytics");

	const { translate } = useLocales();

	return (
		<Page title={translate("products.positions")}>
			<Container maxWidth={"xl"}>
				<PageHeader title={translate("products.positions")} back={false} />
				<ServiceTab currentTab={currentTab} onChangeTab={onChangeTab} />
				{currentTab === "analytics" && <AnalyticsPanel product='ACTIVE_POSITIONS' />}
				{currentTab === "create_url" && <CreateUrlTab />}
			</Container>
		</Page>
	);
};

export default AppPositions;
